import styled from "styled-components";

type SiteHeaderSectionTypes = {
  direction?: string;
};

export const SiteHeaderSection = styled.div<SiteHeaderSectionTypes>`
  position: fixed;
  z-index: 100;
  width: 100%;
  background-color: ${(props) => props.theme.colors.b.wh};
  transition: all 0.7s ease-in-out;

  top: ${(props) => (props.direction === "up" ? "-100%" : "0")};

  > section {
    ${(props) => props.theme.layout.sectionInner};
    background-color: ${(props) => props.theme.colors.b.wh};
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 100;
    border-bottom: 1px dotted ${(props) => props.theme.colors.b.lg};
  }

  .logo {
    padding: 24px 0;
  }

  .prn {
    display: flex;
    justify-content: space-between;
    align-items: center;

    > a {
      padding: 0 0 0 14px;
    }
  }

  .user {
    a {
      color: ${(props) => props.theme.colors.b.bk};
      font-size: 14px;
      display: inline-block;
      &:first-child:after {
        content: "|";
        display: inline-block;
        padding: 0 6px;
        color: ${(props) => props.theme.colors.b.lg};
      }
    }
  }

  @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
    height: 48px;
    padding: 0 4%;
   
    .logo {
      padding: 14px 0;
      img {
        width: 134px; 
      }
    }

    .prn {
      img {
        height: 24px;
      }

      > a,
      > button, 
      > div {
        padding: 0 4px;
      }
    }
    
    .user {
      padding: 22px 4% 0 4%;
      text-align: right;
      a {
        font-size: 12px;
        color: ${(props) => props.theme.colors.b.wh};
      }
    }

    .mobile-header {
      padding: 0 4%;
      display: flex;
      alidnm-items: center;
      justify-content: space-between;

      .mobile-prn {
        display: flex;
        align-items: center;
        justify-content: space-between;
        button {
          padding: 0 8px;
        }
      }

      .mobile-logo {
        padding: 14px 0;
      }
    }
  }
`;
